export default {"src":"/_next/static/media/v4.3a8a5b15.svg","height":130,"width":332};